import React, { useMemo } from "react";
import { highlight, renderInlineMarkdown, renderMarkdown } from "../lib/markdown";

// Content comes from our own YAML and markdown-it runs with `html: false`, so the HTML is escaped.
export function Markdown({ source, className = "" }) {
  const html = useMemo(() => renderMarkdown(source), [source]);
  return <div className={`prose ${className}`} dangerouslySetInnerHTML={{ __html: html }} />;
}

export function InlineMarkdown({ source, as: Tag = "span", className }) {
  const html = useMemo(() => renderInlineMarkdown(source), [source]);
  return <Tag className={className} dangerouslySetInnerHTML={{ __html: html }} />;
}

export function CodeBlock({ code, language = "python", className = "" }) {
  const html = useMemo(() => highlight(code.replace(/\n+$/, ""), language), [code, language]);
  return (
    <pre className={`code-block ${className}`}>
      <code className="hljs" dangerouslySetInnerHTML={{ __html: html }} />
    </pre>
  );
}
